import React from "react";
import { Images, ClipboardCheck, FlaskConical, Eye, CalendarClock, RefreshCw, ShieldCheck, FileCheck2 } from "lucide-react";

const content = [
  { icon: Images, t: "Före- och efterbilder" },
  { icon: ClipboardCheck, t: "Vad som utförts" },
  { icon: FlaskConical, t: "Använda behandlingar & material" },
  { icon: Eye, t: "Observerat skick" },
  { icon: RefreshCw, t: "Rekommenderat underhåll" },
  { icon: CalendarClock, t: "Nästa rekommenderade kontroll" },
  { icon: ShieldCheck, t: "Garantiinformation" },
];

export default function Takrapport() {
  return (
    <section className="bg-white py-16 lg:py-24">
      <div className="mx-auto max-w-7xl px-6 grid lg:grid-cols-2 gap-12 items-center">
        <div className="reveal">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-[#1B45C4]">Digital takrapport</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold text-slate-900">
            Ditt tak. Dokumenterat från första dagen.
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Efter avslutat arbete får du en digital takrapport – en tydlig sammanställning av vad som
            gjorts, hur taket mår och vad som rekommenderas framåt. Enkelt att spara, dela och ta fram
            vid en eventuell försäljning.
          </p>
          <div className="mt-8 grid sm:grid-cols-2 gap-3">
            {content.map((c) => (
              <div key={c.t} className="flex items-center gap-3 rounded-xl bg-[#f0f7ff] px-4 py-3 ring-1 ring-[#dbeafe]">
                <c.icon className="w-5 h-5 shrink-0 text-[#1B45C4]" />
                <span className="text-sm font-semibold text-slate-800">{c.t}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Rapport-mockup */}
        <div className="reveal">
          <div className="rounded-[28px] bg-slate-900 p-6 shadow-2xl shadow-[#1B45C4]/20 ring-1 ring-black/5">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <FileCheck2 className="w-5 h-5 text-[#38BDF8]" />
                <span className="font-brand text-lg font-extrabold text-white">HPR Takrapport</span>
              </div>
              <span className="rounded-full bg-[#38BDF8]/20 px-3 py-1 text-xs font-bold text-[#38BDF8]">Klar</span>
            </div>
            <div className="mt-5 grid grid-cols-2 gap-3">
              <div className="rounded-xl bg-white/5 p-3 ring-1 ring-white/10">
                <p className="text-[11px] uppercase tracking-wide text-white/50">Före</p>
                <div className="mt-2 h-24 rounded-lg bg-gradient-to-br from-slate-600 to-slate-800" />
              </div>
              <div className="rounded-xl bg-white/5 p-3 ring-1 ring-white/10">
                <p className="text-[11px] uppercase tracking-wide text-white/50">Efter</p>
                <div className="mt-2 h-24 rounded-lg bg-gradient-to-br from-[#1B45C4] to-[#38BDF8]" />
              </div>
            </div>
            <div className="mt-4 space-y-2">
              {["Utförd behandling: Mjuktvätt + algbehandling", "Observerat skick: Gott – enstaka mossrester", "Nästa kontroll: om 12 månader", "Garanti: registrerad"].map((r) => (
                <div key={r} className="flex items-center gap-2 rounded-lg bg-white/5 px-3 py-2 text-sm text-white/80 ring-1 ring-white/10">
                  <span className="h-1.5 w-1.5 rounded-full bg-[#38BDF8]" /> {r}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
